// extracted by mini-css-extract-plugin
export var gif = "_mc-0";